import {
  FileType,
  LayerClampedStatus,
  LayerResponseClampedStatus,
  LayerResponseType,
  LayerType,
} from './enums';

export const layerTypeResponseMapping = {
  [LayerResponseType.Cesium]: LayerType.Cesium,
  [LayerResponseType.Contour]: LayerType.Contour,
  [LayerResponseType.MBTiles]: LayerType.MBTiles,
  [LayerResponseType.MapBox]: LayerType.MapBox,
  [LayerResponseType.Orthomosaic]: LayerType.Orthomosaic,
  [LayerResponseType.SlopeMap]: LayerType.SlopeMap,
  [LayerResponseType.Vector]: LayerType.Vector,
  [LayerResponseType.CapturedDsm]: LayerType.CapturedDsm,
  [LayerResponseType.PointCloud]: LayerType.PointCloud,
  [LayerResponseType.Cad]: LayerType.Cad,
} as const;

export const layerClampedStatusResponseMapping = {
  [LayerResponseClampedStatus.AlreadyClamped]:
    LayerClampedStatus.AlreadyClamped,
  [LayerResponseClampedStatus.Done]: LayerClampedStatus.Done,
  [LayerResponseClampedStatus.Processing]: LayerClampedStatus.Processing,
  [LayerResponseClampedStatus.Failed]: LayerClampedStatus.Failed,
  [LayerResponseClampedStatus.Started]: LayerClampedStatus.Started,
  [LayerResponseClampedStatus.NotClamped]: LayerClampedStatus.NotClamped,
} as const;

export const layerResponseTypeMapping = {
  [LayerType.Cesium]: LayerResponseType.Cesium,
  [LayerType.Contour]: LayerResponseType.Contour,
  [LayerType.MBTiles]: LayerResponseType.MBTiles,
  [LayerType.MapBox]: LayerResponseType.MapBox,
  [LayerType.CapturedDsm]: LayerResponseType.CapturedDsm,
  [LayerType.Orthomosaic]: LayerResponseType.Orthomosaic,
  [LayerType.SlopeMap]: LayerResponseType.SlopeMap,
  [LayerType.Vector]: LayerResponseType.Vector,
  [LayerType.PointCloud]: LayerResponseType.PointCloud,
  [LayerType.KML]: LayerResponseType.Vector,
  [LayerType.Cad]: LayerResponseType.Cad,
} as const;

export const fileTypeMapping = {
  [LayerType.MBTiles]: FileType.MBTiles,
  [LayerType.CapturedDsm]: FileType.CapturedDsm,
  [LayerType.Orthomosaic]: FileType.Orthomosaic,
  [LayerType.PointCloud]: FileType.PointCloud,
  [LayerType.Cad]: FileType.Vectors,
};

export const vectorTypes = [LayerType.Vector, LayerType.KML];
